import { Route, Routes } from 'react-router'
import { AddNumberLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumber/layout/AddNumberLayout'
import { HowAddNumber } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumber/ui/HowAddNumber/HowAddNumber'

export const AddNumberRouter = () => {
  return (
    <Routes>
      <Route element={<AddNumberLayout />}>
        <Route path='/' element={<HowAddNumber />} />
      </Route>
    </Routes>
  )
}
